<template>
  <div
    v-if="isNoData"
    class="unicom-blank-page">
    <van-empty
      :image="imgUrl ? imgUrl : '/pub/online/20240318/111f3001f4b2d44a.png'"
      :description="text"
      class="custom-image" />
  </div>
</template>

<script>
export default {
  name: 'UnicomBlankPage',
  props: {
    // 是否无数据：true是，false否
    isNoData: {
      type: Boolean,
      required: true
    },
    imgUrl: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      required: true
    }
  },
  mounted () {
    if (this.width && this.height) {
      const box = document.querySelector('.van-empty__image')
      box.style.width = this.width
      box.style.height = this.height
    }
  },
  methods: {}
}
</script>

<style lang="less" scoped>
.unicom-blank-page {
  height: 100vh;
  text-align: center;
  color: #666666;
  background: #fff;
  .custom-image {
    padding-top: 1rem;
    .van-empty__image {
      width: 3.2rem;
      height: 3.2rem;
    }
  }
}
</style>
